import { sendGet, sendPost, sendPut } from './axios';
import { IsSortCountryNumber } from 'common';
// eslint-disable-next-line import/prefer-default-export
export const loadListNotify = () => sendGet('/lp/notification');
export const loadDetailNotify = (id: any) => sendGet(`/lp/notification/detail/${id}`);
export const loadProfile = () => sendGet('/profile');
export const updateProfile = (payload: any) => sendPut('/profile', payload);
export const updateEmailAddress = (payload: any, idEmail: number) =>
  sendPut(`/profile/${idEmail}/update-email`, payload);
export const addAddressProfile = (payload: any) => sendPost('/profile/address', payload);
export const updateAddressProfile = (payload: any, idAddressProfile: number) =>
  sendPut(`/profile/${idAddressProfile}/update-address`, payload);
export const deleteProfileAddress = (idAddressProfile: any) => sendPut(`/profile/${idAddressProfile}/delete-address`);
export const deleteProfileEmail = (idEmailProfile: any) => sendPut(`/profile/${idEmailProfile}/delete-email`);
export const loadAddressProfileFilter = (filter: any) =>
  sendGet(`/profile/address?keyword=${filter?.keyword}&isSort=${filter?.isSort}`);
export const loadAddressProfile = () => sendGet(`/profile/address`);
export const loadEmailsProfile = () => sendGet('/profile/emails');
export const createdEmailProfile = (payload: any) => sendPost('/profile/emails', payload);
export const loadConfig = () => sendGet('/config');
export const upgradeAccount = (payload: any) => sendPut('/profile/request-upgrade', payload);
export const removeAccount = () => sendPut('/profile/remove');
export const changePassword = (payload: any) => sendPut('/auth/change-password', payload);
export const getInfoCard = () => sendGet('/card/info');
export const createCardSetupIntent = () => sendPost('/card/setup-intent');
export const changePaymentCard = (payload: any) => sendPut('/card', payload);
export const hiddenIntro = () => sendPost('/profile/hidden-intro');
export const getDraftOrder = (orderType: any) => sendGet(`/order-draft?orderType=${orderType}`);
export const getPackages = () => sendGet('/profile/packages');
export const updatePackage = (id: any, payload: any) => sendPut(`/profile/${id}/update-package`, payload);
export const addPackage = (payload: any) => sendPost(`/profile/packages`, payload);
export const deletePackage = (id: any) => sendPut(`/profile/${id}/delete-package`);
